function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "color",
  fillRule: "evenodd",
  d: "M.344 15.692c-.459.528-.459 1.384 0 1.912.46.528 1.204.528 1.663 0l6.649-7.648c.459-.528.459-1.384 0-1.912L2.006.396C1.549-.132.804-.132.345.396c-.459.528-.459 1.384 0 1.912L6.162 9 .344 15.692z"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#F58220",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 18
  }, props), _ref);
}

export default SvgArrowRight;